<script setup>
import { computed, defineOptions, onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

defineOptions({ name: 'AbratelPanelIframe' });

const route = useRoute();
const iframeEl = ref(null);

const isDark = ref(document.body.classList.contains('dark'));

const panelUrl = computed(() => {
  const file = route.meta?.panelFile || 'backup.html';
  const accountId = route.params?.accountId || '';
  const theme = isDark.value ? 'dark' : 'light';
  return `/_panel/${file}?account_id=${accountId}&embedded=1&theme=${theme}`;
});

let themeObserver = null;
const postTheme = () => {
  iframeEl.value?.contentWindow?.postMessage(
    { type: 'abratel:theme', theme: isDark.value ? 'dark' : 'light' },
    '*'
  );
};
watch(isDark, postTheme);

onMounted(() => {
  themeObserver = new MutationObserver(() => {
    isDark.value = document.body.classList.contains('dark');
  });
  themeObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
});
onBeforeUnmount(() => {
  themeObserver?.disconnect();
});
</script>

<template>
  <iframe
    ref="iframeEl"
    :src="panelUrl"
    class="w-full h-full border-0 block"
    allow="clipboard-write"
    @load="postTheme"
  />
</template>
